import { onboardingEn, onboardingEs } from "./onboarding";
import { storeMenuEn, storeMenuEs } from "./storeMenu";
import { storeEditEn, storeEditEs } from "./storeEdit";
import { emptyStatesEn, emptyStatesEs } from "./emptyStates";
import { resaleEn, resaleEs } from "./resale";

/**
 * Namespaced strings for the screens matched to the app. Each file exports
 * `{ <namespace>: { ... } }` objects; they are merged on top of the main
 * dictionaries, so `t("<namespace>.<key>")` works like any other key.
 */
export const parityEn: Record<string, unknown> = { ...onboardingEn, ...storeMenuEn, ...storeEditEn, ...emptyStatesEn, ...resaleEn };
export const parityEs: Record<string, unknown> = { ...onboardingEs, ...storeMenuEs, ...storeEditEs, ...emptyStatesEs, ...resaleEs };
